import { createHttpLink } from '@apollo/client';

export const createHttpLinkWithUri = (uri) => createHttpLink({
  uri,
  credentials: 'include',
});
